import SherlockConstant, {
  initialPointProductsItemState,
  initialPointStatusState,
  initialPointHistoryItemState,
} from "@/mixins/sherlock/const/sherlockConstant.js";
import SherlockAcConstant from "@/mixins/sherlock/const/sherlockAcConstant.js";
import { callGetApi, callPostApi, callPatchApi, callDeleteApi } from "@/utils/apiWrapper";

export const state = {
  _isFreeTrialUser: false, // 무료체험 유저인지 여부.
  _isFreeTrialStarted: false, // 무료체험 시작한 유저인지 여부.
  _isFreeTrialExpired: false, // 무료체험 종료 여부.
  _isZeroResultUser: false, // 0건 무차감 유저인지 여부.
  _hasRegisteredCard: false, // 카드 등록 여부.
  _firstPaymentDone: false, // 첫 결제 완료 여부.
  _freeTrialUserAutoChargePoint: 0, // 무료체험 유저 자동 충전 포인트.
  _freeTrialUserAutoChargeProductCode: "", // 무료체험 유저 자동 충전 상품 코드.
};

export const mutations = {
  setIsFreeTrialUser(state, sherlockUser) {
    state._isFreeTrialUser = sherlockUser?.isFreeTrialUser === true;
    state._isFreeTrialStarted = sherlockUser?.isFreeTrialStarted === true;
    state._isFreeTrialExpired = sherlockUser?.isFreeTrialExpired === true;
    state._isZeroResultUser = sherlockUser?.userType === "zero_result";
    state._firstPaymentDone = sherlockUser?.firstPaymentDone === true;
    state._freeTrialUserAutoChargePoint = sherlockUser?.freeTrialAutoChargeAmount;
    state._freeTrialUserAutoChargeProductCode = sherlockUser?.freeTrialAutoChargeProductCode;
  },
  setHasRegisteredCard(state, hasRegisteredCard) {
    state._hasRegisteredCard = hasRegisteredCard;
  },
};

export const actions = {
  /**************************************************************
   * 셜록 사용자 정보 조회
   **************************************************************/
  async acGetSherlockUserInfo({ commit }) {
    const res = await callGetApi({
      url: `${SherlockAcConstant.GET_SHERLOCK_USER_INFO}`,
      params: {},
      commit,
    });
    if (process.env.NODE_ENV === "development") {
      window.console.log("[acGetSherlockUserInfo] res: ", res);
    }
    if (res?.sherlockUser != null) {
      commit("setIsFreeTrialUser", res?.sherlockUser);
      commit("setHasRegisteredCard", res?.sherlockUser?.cardRegistered === true);
    }
    return res;
  },

  /**************************************************************
   * 셜록 사용자 등록
   * agreement_yn, // 확약 동의 여부
   **************************************************************/
  async acPostSherlockUserCreate({ commit }, { agreement_yn, freetrial }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_USER_CREATE}`,
      data: {
        agreement_yn,
        freetrial,
      },
      commit,
    });
    // window.console.log("[acPostSherlockUserCreate] res: ", res);
    return res;
  },
};

export const getters = {
  dealPointAmount: (state) => state._isZeroResultUser ? 100 : 60,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
